import {bindTypesToActions} from '@src/utils/redux_utils';

const types={
    SetLoader: 'COMMON_SET_LOADER',
    SetError: 'COMMON_SET_ERROR'
}

const CommonActions = bindTypesToActions( types );

/** STATE INTERFACE
 * loading: boolean,
 * Errors: {
 *          message: string,
 *          type: string,
 *          data: Object
 *          }
 */

const initialState={
   Loading: false,
   Errors: null
}

const CommonReducer = ( state = initialState, { type, payload } ) => {
    switch(type){
        case types.SetLoader:
           
            const Loading = typeof( payload ) === 'boolean'? payload: false ;

            return {
                ...state, Loading
            } 
        case types.SetError:
            const Errors = payload ;
            
            return {
                ...state, Errors
            }  

        default: return state;    
    }
}

export {
    types as CommonTypes,
    CommonReducer,
    CommonActions
}